export const paymentTypes = {
    commodity: 'товара',
    payment: '',
    job: 'работы',
    service: 'услуги',
    another: '',
};

/**
 * Payment Periods map.
 */
export const paymentPeriods = {
    1: 'день',
    7: 'неделю',
    14: 'две недели',
    28: 'четыре недели',
    30: 'месяц',
    60: '2 мес.',
    90: '3 мес.',
    180: '6 мес.',
    365: 'год',
};
